import { useState, useEffect } from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from 'react-bootstrap/Tab'
import TablaContratos from "./TablaContratos";
import { useContratos } from "../../components/contratos/ContratosProvider";
import { useSearch } from "../../components/search/SearchProvider";
import PerfilCliente from "../perfilCliente/PerfilCliente"
import ToastNotificacion from "../../components/notificaciones/ToastNotificacion";
import LoaderC from "../../components/helpers/LoaderC";
/**
 * COMPONENTE PRINCIPAL
 * @returns {JSX.Element}
 * @constructor
 */
export default function Contrato() {
    /**
     * Arreglo de tabs (id del contrato)
     */
    const [tabs, setTabs] = useState([]);

    /**
     * Hook de búsqueda
     */
    const { loader, activekey, setActiveKey } = useSearch();

    useEffect(() => {
        setActiveKey('home');
    }, [setActiveKey]);

    /**
     * @function handleAddTab Primero se comprueba que no exista el Tab (por el id del contrato), si no existe lo crea
     * @param id_contrato
     * @param id_cliente
     * @param title
     */
    function handleAddTab(id_contrato, id_cliente ,title) {
        /**
         * Comprobar las sí ya existe el id en el arreglo tabs
         * ( some() detiene el recorrido del array cuando encuentra una coincidencia, puede comparar objetos )
         * @type {boolean}
         */
        const exists = tabs.some(t => t.id_contrato === id_contrato);
        /**
         * Sí no existe se agrega el id del contrato al arreglo
         */
        if (!exists) {

            setTabs(prevTabs => [...prevTabs, {
                id_contrato: id_contrato,
                id_cliente: id_cliente,
                title: title,
            }]);

        }
        /**
         * Se activa el tab que se acaba de crear
         */
        setActiveKey(id_contrato);
    }

    /**
     * @function handleDeleteTab Eliminar tab
     * @param e
     * @param tabId
     */
    function handleDeleteTab(e, tabId) {
        e.stopPropagation();
        /**
         * Eliminar id de contrato del arreglo de tabs
         */
        setTabs(
            tabs.filter(t => t.id_contrato !== tabId)
        );
        /**
         * Se activa el id 'home' (tabla de contratos)
         */
         setActiveKey('home');
    }

    return (
        <>
            <style type='text/css'>
                {`
                    @media (max-width: 767.98px) {
                    
                        .nav-tabs-fiducia .nav-item .nav-link i:before {
                            margin-top: -6px!important;
                        }
                        .nav-tabs-fiducia .nav-item .nav-link span:before {
                            margin-top: -8px!important;
                        }
                        
                    }
                    
                    @media (max-width: 767.98px) {
                    
                        .nav-item .nav-link span:after{
                            margin-top : 2px!important;
                        }
                        
                    }
                    
                    @media(min-width:768px) {
                        .mt-md-min {
                            margin-top : 0.15rem!important;
                        }
                    }

                    .nav-tabs-fiducia {
                        position : sticky;
                        top : 5.769230769rem;
                        z-index : 7;
                        flex-wrap : nowrap!important;
                        overflow-x : auto!important;
                    }
                    
                    @media (max-width: 991.98px) {
                        .nav-tabs-fiducia {
                            position : sticky;
                            top : 4.615384615rem;
                            z-index : 7;
                        }
                    }
                  
                `}
            </style>
            <ToastNotificacion></ToastNotificacion>
            <Tabs
                className={"nav-tabs-fiducia"}
                defaultActiveKey={'home'}
                transition={false}
                activeKey={activekey}
                onSelect={(eventKey, e) => {
                    e.stopPropagation();
                    setActiveKey(eventKey);
                }}
            >
                <Tab title={<>Clientes <span></span></>} eventKey={'home'}>
                    {
                        loader ? (
                            <LoaderC></LoaderC>
                        ) : (
                            <ContentResul handleAddTab={handleAddTab} setActiveKey={setActiveKey}></ContentResul>
                        )
                    }
                </Tab>
                {
                    tabs && tabs.length > 0 && tabs.map((t) => {
                        return(
                            <Tab key={t.id_contrato}
                                 title={
                                <>
                                    <b className={"text-truncate mw-100px d-inline-block fw-normal mt-1 mt-md-min"}>{t.title}</b><i onClick={(e) => handleDeleteTab(e, t.id_contrato)}></i>
                                </>}
                                 eventKey={t.id_contrato}
                            >
                                <div className={'px-4'}>
                                    <PerfilCliente contratoId={t.id_contrato} clienteId={t.id_cliente}></PerfilCliente>
                                </div>
                            </Tab>
                        )
                    })
                }
            </Tabs>
        </>
    );
}


function ContentResul({
  handleAddTab,
}){
    /**
     * Hook contratos
     */
    const { contratos } = useContratos();
    /**
     * Hook finder
     */
    const { message } = useSearch();

    if (Array.isArray(contratos) && contratos.length > 0){
        return (
            <div className={"ps-4"}>
                <TablaContratos contratos={contratos} handleAddTab={handleAddTab}></TablaContratos>
            </div>
        );
    } else if(message.length > 0){
        return (
            <div className={"position-relative"} style={{height: "10rem"}}>
                <div className={"position-absolute top-50 start-50 translate-middle"}>
                    <i className="bi bi-emoji-frown fs-3tx text-warning"></i>
                </div>
                <br/>
                <span className={"position-absolute bottom-0 start-50 translate-middle-x fw-semibold fs-5"}>
                    {message}
                </span>
            </div>
        )
    } else {
        return (
            <div className={"position-relative"} style={{height: "10rem"}}>
                <div className={"position-absolute top-50 start-50 translate-middle"}>
                    <i className="ki-duotone ki-search-list fs-5hx text-primary">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                    </i>
                </div>
                <br/>
                <span className={"position-absolute bottom-0 start-50 translate-middle-x fw-semibold fs-5"}> Búsqueda de clientes</span>
            </div>
        );
    }
}


